import stringify from 'json-stringify-safe';
import type { IHttpError } from '@wix/http-client';
import { HttpClient } from '@wix/yoshi-flow-editor';

export const toError = (e: unknown): Error =>
  e instanceof Error ? e : new Error(typeof e === 'string' ? e : stringify(e));

export const getApplicationErrorCode = (e: any) => e?.response?.data?.details?.applicationError?.code;

export const getApplicationErrorData = (e: unknown): Record<string, unknown> | undefined => {
  if (HttpClient.isHttpError(e)) {
    return e.response?.data.details?.applicationError?.data;
  }

  return undefined;
};

export function isWixHttpError(error: unknown): error is IHttpError {
  return Boolean(error && error instanceof Error && (error as any).isWixHttpError);
}

export const isNetworkError = (e: unknown) => isWixHttpError(e) && e.message === 'Network Error';
export const is403 = (e: unknown) => isWixHttpError(e) && e.response?.status === 403;
export const is401 = (e: unknown) => isWixHttpError(e) && e.response?.status === 401;

export async function ignoreErrors<T>(action: () => T | Promise<T>) {
  try {
    return await action();
  } catch {}
}
